import { useSelector, useDispatch } from "react-redux";
import { setCurrentUser, setProfileShowDeposit } from "../reducers/authSlice";
import { useNavigate } from "react-router-dom";
import { BanknoteArrowUp, LogIn, LogOut } from "lucide-react";
import { toast } from "react-toastify";
import Services from "../services/services";
import { flushSync } from "react-dom";

export default function Header() {
    const authStore = useSelector((state) => state.auth);
    const {
        currentPage
    } = useSelector((state) => state.general);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleLogout = () => {
        toast.info(
            <div>
                <p>Are you sure you want to log out of this device?</p>
                <div className="mt-2 flex gap-2">
                    <button
                        onClick={() => { toast.dismiss(); handleConfirmLogout(true); }}
                        className="px-3 py-1 bg-blue-500 text-white rounded"
                    >
                        LogOut
                    </button>
                    <button
                        onClick={() => toast.dismiss()}
                        className="px-3 py-1 bg-gray-500 text-white rounded"
                    >
                        Cancel
                    </button>
                </div>
            </div>,
            { position: "top-center", autoClose: false, closeOnClick: false }
        );
    }
    const handleConfirmLogout = async () => {
        const res = await Services.UserAuth.logout();
        const data = await res.json();
        if (res.ok) {
            flushSync(() => { dispatch(setCurrentUser(null)) });
            navigate('/auth');
        } else {
            toast.error(`${res.status}: ${data.error ?? ""}`)
        }
    }
    const handleDeposit = () => {
        dispatch(setProfileShowDeposit(true));
        navigate('/user')
    }
    return (
        <header className="fixed w-full h-16 bg-gray-900 flex items-center justify-between px-2 px-4 pl-20 pr-5 text-white shadow z-10 transition-all duration-200">
            {/* Logo & Title */}
            <div
                className="flex items-center gap-2 text-lg sm:text-xl font-bold cursor-pointer truncate max-w-[55vw] sm:max-w-xs md:max-w-md"
                onClick={() => navigate("/")}
                title="Go to homepage"
            >
                <img
                    src="https://cdn-icons-png.flaticon.com/512/124/124010.png"
                    alt="AK API Logo"
                    className="w-8 h-8 mr-1 hidden xs:inline-block"
                    loading="lazy"
                />
                <span className="truncate">AK API{currentPage?.name ? ` - ${currentPage.name}` : ""}</span>
            </div>
            {/* User Actions - always fixed at top right */}
            <div className="absolute right-2 sm:right-4 top-0 h-16 flex items-center gap-2 sm:gap-4 bg-gray-900 pl-2">
                {authStore.user ? (
                    <>
                        <span className="font-semibold truncate max-w-[70px] sm:max-w-[140px]">
                            {authStore.user.display_name || authStore.user.username}
                        </span>
                        <span
                            onClick={handleDeposit}
                            className="flex gap-2 items-center bg-gray-700 hover:bg-green-500 cursor-pointer px-3 py-1 rounded text-base"
                            title="Balance - Click to Deposit"
                        >
                            ${authStore.user.balance?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            <BanknoteArrowUp/>
                        </span>
                        <button
                            onClick={handleLogout}
                            className="px-3 py-1 bg-red-500 hover:bg-red-700 sm:px-3 rounded text-white font-semibold flex gap-1 sm:gap-2 items-center text-xs sm:text-base"
                        >
                            <LogOut size={24} /> <span className="hidden xs:inline">Log-out</span>
                        </button>
                    </>
                ) : (
                    <button
                        onClick={() => navigate('/auth')}
                        className="px-3 py-1 bg-green-500 hover:bg-green-700 m:px-3 rounded text-white font-semibold flex gap-1 sm:gap-2 items-center text-xs sm:text-base"
                    >
                        <LogIn size={24} /> <span className="hidden xs:inline">Login / Register</span>
                    </button>
                )}
            </div>
        </header>
    );
}